import AgentEdit from './AgentEdit'

export default {
  name: 'AgentEditView',
  extends: AgentEdit,
  created() {
    const bus = this.$bus
    if (!bus.params.token || !bus.params.tenantId) {
      this.$router.replace({
        name: 'preview'
      })
    }
  }
}
